import http from "@/tools/http";

export default {
  create(organizationUUID, dashboard) {
    return http.post(`/organizations/${organizationUUID}/dashboards`, dashboard);
  },
  getAll(organizationUUID) {
    return http.get(`/organizations/${organizationUUID}/dashboards`);
  },
  delete(organizationUUID, dashboardUUID) {
    return http.delete(`/organizations/${organizationUUID}/dashboards/${dashboardUUID}`);
  },
  getOne(organizationUUID, dashboardUUID) {
    return http.get(`/organizations/${organizationUUID}/dashboards/${dashboardUUID}`);
  },
  update(organizationUUID, dashboard) {
    return http.patch(`/organizations/${organizationUUID}/dashboards/${dashboard.uuid}`, dashboard);
  },
  switch(organizationUUID, dashboardUUID) {
    return http.patch(`/organizations/${organizationUUID}/dashboards/${dashboardUUID}/switch`);
  },
  duplicate(organizationUUID, dashboard) {
    return http.post(`/organizations/${organizationUUID}/dashboards/${dashboard.uuid}/duplicate`, dashboard);
  },
  getLive(dashboardHash) {
    return http.get(`/live/${dashboardHash}`);
  },
  createChart(organizationUUID, chart, dashboardUUID) {
    return http.post(`/organizations/${organizationUUID}/dashboards/${dashboardUUID}/charts`, chart);
  },
  deleteChart(organizationUUID, chartUUID, dashboardUUID) {
    return http.delete(`/organizations/${organizationUUID}/dashboards/${dashboardUUID}/charts/${chartUUID}`);
  },
  updateChart(organizationUUID, chart, dashboardUUID, onlyLayout) {
    let url = `/organizations/${organizationUUID}/dashboards/${dashboardUUID}/charts/${chart.uuid}`;
    if (onlyLayout) {
      url += "?patchPosition=true";
    }

    return http.patch(url, chart);
  },
  getOneChart(organizationUUID, dashboardUUID, chartUUID, pagination) {
    return http.get(`/organizations/${organizationUUID}/dashboards/${dashboardUUID}/charts/${chartUUID}`, {
      params: pagination
    });
  },
  getOneChartByDashboardHash(dashboardHash, chartUUID) {
    return http.get(`/live/${dashboardHash}/chart/${chartUUID}`);
  }
};
